<template>
  <div id="hcp-categories">
    <mu-content-block class="contentLoader" v-if="isLoading">
      <mu-circular-progress :size="48"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <div id="categories" class="content" v-if="!isLoading">
      <mu-flexbox class="row" :gutter="16" v-for="chunks, index in chunkedItems" :key="'chunk-' + index" v-if="!isLoading">
        <mu-flexbox-item class="cat" v-for="cat, index in chunks" :key="'cat-' + index" :style="'background-image: url(' + cat.image + ');'">
          <mu-flexbox justify="flex-start" align="center" class="cat">
            <mu-card @click.native="goTo(cat.slug)">
              <mu-card-text>
                <div class="cat-desc">
                  <h3 class="largeTitle">
                    <span v-once>{{cat.name}}</span>
                  </h3>
                  <div class="desc">
                    <div class="extract">
                      <div>{{cat.description}}</div>
                    </div>
                    <span class="view-all">View All</span>
                  </div>
                </div>
              </mu-card-text>
            </mu-card>
          </mu-flexbox>
        </mu-flexbox-item>
      </mu-flexbox>
    </div>
  </div>
</template>
<script>
  import './Categories.less';
  import config from '../../../config'
  import hcpApi from '../../../api/Hcp';
  export default {
    data() {
      return {
        isLoading: true,
        categories: [],
      }
    },
    methods: {
      getCats() {
        let self = this;
        hcpApi.getCategories('large').then(response => {
          self.categories = response.data;
          self.isLoading = false;
        });
      },
      initMounted() {
        let self = this;
        self.getCats();
      },
      goTo(slug) {
        let self = this;
        self.$router.push({
          name: 'HcpCategory',
          params: {
            slug: slug
          }
        })
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
    },
    computed: {
      chunkedItems () {
        let self = this;
        return _.chunk(_.toArray(self.categories), 2);
      }
    },
  }
</script>



// WEBPACK FOOTER //
// Categories.vue?62ccf3d2